import Api from '../../scripts/api';
import { ActionContext, ActionTree, MutationTree } from 'vuex';

enum MutationTypes {
    FETCHING = 'FETCHING',
    FETCHED = 'FETCHED',
}

export const STATES = {
    INIT: Symbol('INIT'),
    FETCHING: Symbol('FETCHING'),
    FETCHED: Symbol('FETCHED'),
};

type State = {
    unreadCount: null | number
    state: symbol
};

type ApiData = {
    amountUnread: number,
}

type MutationsWithoutParameter<S = State> = {
    [MutationTypes.FETCHING](state: S): void
}
type MutationsWithOneParameter<S = State> = {
    [MutationTypes.FETCHED](state: S, data: ApiData): void
}
// TODO check if this can be done easier (we need this to have correct typing in the commit() calls with different parameter sets)
type Mutations<S = State> = MutationsWithoutParameter & MutationsWithOneParameter;

const state: State = {
    unreadCount: null,
    state: STATES.INIT,
};

type AugmentedActionContext = {
    commit<K extends keyof MutationsWithoutParameter>(
        key: K
    ): ReturnType<MutationsWithoutParameter[K]>
} & {
    commit<K extends keyof MutationsWithOneParameter>(
        key: K,
        payload: Parameters<MutationsWithOneParameter[K]>[1]
    ): ReturnType<MutationsWithOneParameter[K]>
} & Omit<ActionContext<State, State>, 'commit'>

interface Actions {
    fetchCount({ commit }: AugmentedActionContext): Promise<void>
}

const actions: ActionTree<State, State> & Actions = {
    async fetchCount ({ commit, state }) {
        if (state.state !== STATES.INIT) {
            return;
        }

        commit(MutationTypes.FETCHING);

        const result: ApiData = await Api.version(1).get<ApiData>('rocketchat/unread');

        commit(MutationTypes.FETCHED, result);
    },
};

const getters = {
    unreadCount (state: State): null | number {
        return state.unreadCount;
    },

    state (state: State) {
        return state.state;
    },
};

const mutations: MutationTree<State> & Mutations = {
    FETCHING (state) {
        state.state = STATES.FETCHING;
    },

    FETCHED (state, data: ApiData) {
        state.state = STATES.FETCHED;
        state.unreadCount = data.amountUnread;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
